const inDevelopmentMode = process.env.NODE_ENV === `development`; // eslint-disable-line no-undef

export default inDevelopmentMode;
